import { defineStore } from 'pinia'
import { ILoginResultDTO } from '@/services/usuariosService'

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null as ILoginResultDTO | null,
    token: '',
    isAuthenticated: false,
    tipoId: 0,
    tipo: 'indefinido',
    permissoes: [] as string[],
  }),

  getters: {
    getUser(): ILoginResultDTO | null {
      return this.user
    },
    getToken(): string {
      return this.token
    },
    getIsAuthenticated(): boolean {
      return this.isAuthenticated
    },
    getTipoId(): number {
      return this.tipoId
    },
    getTipo(): string {
      return this.tipoId == 1 ? 'Administrador' :
      this.tipoId == 2 ? 'Supervisor' :
      this.tipoId == 3 ? 'Investidor' :
      this.tipoId == 4 ? 'Vendedor' :
      this.tipoId == 5 ? 'Dir. Designer' : 'indefinido'
    }
  },

  actions: {
    setUser(userData: ILoginResultDTO) {
      this.user = userData
      this.token = userData.accessToken || ''
      this.isAuthenticated = true
      this.tipoId = userData.tipoId || 0
      this.permissoes = userData.permissoes || []
      localStorage.setItem('user', JSON.stringify(userData))
      localStorage.setItem('token', this.token)
    },

    setToken(token: string) {
      this.token = token
      this.isAuthenticated = true
    },

    /** Verifica se o usuário tem a permissão com a chave informada. Admin tem tudo. */
    hasPermissao(chave: string): boolean {
      if (this.tipoId === 1) return true
      return this.permissoes.includes(chave)
    },

    logout() {
      this.user = null
      this.token = ''
      this.isAuthenticated = false
      this.tipoId = 0
      this.permissoes = []
      localStorage.removeItem('user')
      localStorage.removeItem('token')
    },

    restoreUser() {
      const savedUser = localStorage.getItem('user')
      const savedToken = localStorage.getItem('token')

      if (savedUser && savedToken) {
        try {
          const userData: ILoginResultDTO = JSON.parse(savedUser)
          this.user = userData
          this.token = savedToken
          this.isAuthenticated = true
          this.tipoId = userData.tipoId || 0
          this.permissoes = userData.permissoes || []
        } catch (error) {
          console.error('Erro ao restaurar usuário:', error)
          this.logout()
        }
      }
    },

    clearUser() {
      this.user = null
      this.token = ''
      this.isAuthenticated = false
      this.permissoes = []
      localStorage.removeItem('user')
      localStorage.removeItem('token')
    }
  }
})
